import React from 'react';
import MediaQuery from 'react-responsive'

export const Desktop = props => <MediaQuery minWidth={769}>{props.children}</MediaQuery>
export const Mobile = props => <MediaQuery maxWidth={768}>{props.children}</MediaQuery>

// export const Desktop = props => <>{props.children}</>//<MediaQuery minWidth={769}>{props.children}</MediaQuery>
// export const Mobile = props => null//<MediaQuery maxWidth={768}>{props.children}</MediaQuery>
